module.exports = __webpack_public_path__ + "assets/img/bg_top.45f75335.png";